// extracted by mini-css-extract-plugin
export default {"cls1":"XlF9MlMCRGN3vN2uP4Ki","cls2":"VOrrlccPjvhE1DQondEQ XlF9MlMCRGN3vN2uP4Ki"};